<template>
    <div class="">
        <div class="">
            <div class="img-container" >
                <img class="banner-bg-desktop" src="@/assets/images/candidatedb/axpara-banner-full.svg" loading="lazy">
                <img class="banner-bg-mobile" src="@/assets/images/candidatedb/banner-mobile.svg" loading="lazy">
            </div>      
            <div class="button-container">
                <div class="customize-exp text-center">
                    Customize your experience by telling us who you are
                </div>
                <div class="container-fluid">
                    <div class="row p-3 button-link-container">
                        <div class="col-sm-6 text-end">
                            <a href="https://axpara.com/talent/">
                                <button class="btn btn-im-talent ">I’m a Talent</button>
                            </a>
                        </div>
                        <div class="col-sm-6 text-start">
                            <button class="btn btn-im-employer" data-bs-toggle="modal" data-bs-target="#LocationModal">I’m an Employer</button>
                        </div>
                    </div>
                </div>
            </div>     
        </div>      
        <LocationModal></LocationModal>  
    </div>
</template>
<script>
import LocationModal from '@/components/modals/LocationModal.vue';
export default {
    name: 'LandingPage',
    data() {
        return {

        }
    },
    components:{
        LocationModal
    }
}
</script>
<style>  
    body, html{
        background-color: #FDFDFD !important;
        width: 100%;
    }
    .banner-bg-desktop{
        display: block;
        width: 100%;
        margin:0px auto;
    }
    .banner-bg-mobile{
        display: none;
    }
    .button-container{
        margin-top:3rem;
    }
    @media screen and (max-width: 1440px) {
        body {
            zoom:75%;
        }
    }    

    .img-container{
        width: 100% !important;
        overflow: hidden;
        min-height: 563.953px;
    }
    .customize-exp{
        font-family: 'LexendDecaMedium';
        font-style: normal;
        font-weight: 500;
        font-size: 26px;
        color: #1C2245;
    }
    .btn-im-talent{
        font-family: 'RubikRegular' !important;
        font-style: normal;
        font-weight: 500 !important;
        font-size: 16px !important;
        padding: 17px 32px;
        width: 186px;
        height: 56px;
        line-height: 100%;
        background: #1C2245 ;
        border-radius: 41px;
        color: #FFFFFF;
    }
    .btn-im-talent:hover{
        background: #323e7a !important;
        color: #FFFFFF !important;
    }
    .btn-im-employer{
        font-family: 'RubikMedium';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        background: #FFFFFF !important;
        color: #1C2245;
        padding: 17px 32px;
        width: 189px;
        height: 56px;
        line-height: 100%;
        border: 1px solid #1C2245;
        border-radius: 41px;

    }
    .btn-im-employer:hover{
        background: #f0f0f3 !important;
        color: #1C2245 !important;
        border: 1px solid #1C2245 !important;
    }
    @media screen and (max-device-width: 600px){
        .btn-im-talent, .btn-im-employer{
            width: 100% !important;
        }
        .btn-im-employer{
            margin-top: 20px;
        }
        .banner-bg-desktop{
            display: none;
        
        }
        .banner-bg-mobile{
            display: block;
            width: 100%;
        }
        .customize-exp{
            font-size: 24px;
        }
        .button-container{
            margin-top: 2rem;
        }
        .button-link-container {
            display: block;
           
        }
        .button-link-container div{
            width: 100% !important;
        }
    
    }
    
</style>